const REDIRECT_AFTER_LOGIN_KEY = "purissima.redirectAfterLogin";
const LEGACY_REDIRECT_AFTER_LOGIN_KEY = "redirectAfterLogin";

const isSafeRedirect = (value) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) return false;
  if (!trimmed.startsWith("/")) return false;
  if (trimmed.startsWith("//")) return false;
  return true;
};

const normalizeRedirect = (value) =>
  isSafeRedirect(value) ? value.trim() : null;

export const setRedirectAfterLogin = (value) => {
  const safe = normalizeRedirect(value);
  try {
    if (safe) {
      localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, safe);
    }
  } catch {}
};

export const getRedirectAfterLogin = (fallback = "/minha-conta/dashboard") => {
  try {
    const raw =
      localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY) ||
      localStorage.getItem(LEGACY_REDIRECT_AFTER_LOGIN_KEY);
    return normalizeRedirect(raw) || fallback;
  } catch {
    return fallback;
  }
};

export const clearRedirectAfterLogin = () => {
  try {
    localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
    localStorage.removeItem(LEGACY_REDIRECT_AFTER_LOGIN_KEY);
  } catch {}
};

export const consumeRedirectAfterLogin = (fallback) => {
  const target = getRedirectAfterLogin(fallback);
  clearRedirectAfterLogin();
  return target;
};

export { REDIRECT_AFTER_LOGIN_KEY, LEGACY_REDIRECT_AFTER_LOGIN_KEY };
